<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="pad12 size14 line20">
    <div class="size14 size16 flex between mb20" v-if="payinfo.claim_status === 2">
      <div class="b500">
        已赔付￥{{payinfo.claim_amount}}
      </div>
      <div class="C999">
        {{ payinfo.claim_time }}
      </div>
    </div>
    <div class="size14 size16 flex between" v-if="payinfo.claim_status === 1 && payinfo.claim_amount > 0">
      <div class="b500 Cred">
        待赔付￥{{payinfo.claim_amount}}
      </div>
      <div class="C999">
        {{ payinfo.claim_time }}
      </div>
    </div>
    <p class="C999 size12 mb20" v-if="payinfo.claim_status === 1 && payinfo.claim_amount > 0">为不影响您个人信誉，请在规定时间内完成赔付！</p>
    <div class="size14 size16 flex between mb20">

      <div class="b500" v-if="$route.query.typeTitle = '取消订单'">
        {{payinfo.status == 4?'已退还':'待退还'}}￥{{payinfo.refund_money}}
      </div>
      <div class="b500" v-else>
        {{payinfo.return_status == 2 ?'已退还':'待退还'}}￥{{payinfo.refund_money}}
      </div>
      <div class="C999">
        {{ payinfo.refund_time }}
      </div>
    </div>
    <p class="b500 size14">赔付明细</p>
    <template v-if="claim.length > 0">
      <div class="flex between start mt15" v-for="item in claim" :key="item.reason">
        <p class="width80">{{ item.reason }}</p>
        ￥{{ item.money }}
      </div>
    </template>
    <!-- <div class="flex between start mt15">
      <p class="width80">包装（纸盒、打包胶带、快递袋、打印单）</p>
      ￥2.00
    </div>
    <div class="flex between start mt15">
      <p class="width80">人工费（库存管理、包装、客服、验收）</p>
      ￥2.00
    </div>
    <div class="flex between start mt15">
      <p class="width80">商品损坏（衣服有勾丝）</p>
      ￥2.00
    </div> -->
    <p class="b500 mt20 size14 mb16">凭证查看</p>
    <div class="flex">
      <img :src="item" @click="openImg(item)" class="height80px width80px BGf4 mr10" v-for="item in payinfo.imgs" :key="item">
      <!-- <img src="@/assets/img/empty.png" @click="openImg()" class="height80px width80px BGf4 mr10" alt=""> -->
      <!-- <video src="" class="height80px width80px BGf4 mr10"></video> -->
    </div>
    <hr class="opacity4 mt15 mb15">
    <div class="size14 flex between mb20">
      <div class="b500">
        取消原因
      </div>
      <div class="C999">
        {{ payinfo.return_reason }}
      </div>
    </div>
    <div class="size14 flex start between mb20">
      <div class="b500">
        原因补充
      </div>
      <div class="C999 width60" style="text-align:right">
        {{ payinfo.reason }}
      </div>
    </div>
    <div class="size14 flex between mb20">
      <div class="b500">
        退还金额
      </div>
      <div class="C999">
        ￥{{ payinfo.refund_money }}
      </div>
    </div>
    <div class="size14 flex between mb20">
      <div class="b500">
        申请时间
      </div>
      <div class="C999">
        {{ payinfo.add_time }}
      </div>
    </div>
  </div>
  <div class="pad30"></div>
  <!-- <div class="fixed l r b pad12">
    <van-button round block type="primary">确认赔付</van-button>
  </div> -->
</template>

<script>
import ajax from "@/utils/request.js";
export default {
  data () {
    return {
      checked: '1',
      payinfo: {},
      claim: []
    }
  },
  watch: {
  },
  methods: {
    openImg (src) {
      if (!src) { return this.showToast('没有图片资源') }
      location.href = src;
    },
    getDetail () {
    },
    apply () {
    },
    next () {
      history.forward()
    }
  },
  created () {
    console.log(this.$route.query);
    ajax.post("order/cancelinfo", { id: this.$route.query.order_id }).then(res => {
      this.payinfo = res.data

      console.log(this.payinfo);
      console.log('this.payinfo');
      const arr = []
      this.payinfo.claim_json.forEach(item => {
        if (item.money > 0) {
          arr.push(item)
        }
      })
    })
  }
}
</script>

<style>
</style>
